import React from "react"
import { extractLangAndCountry } from "../../utility/lang"
import { sanitizeUrl } from "@braintree/sanitize-url"
import PropTypes from "prop-types"

export const HelmetSeo = ({ title, description, image, location, siteGraphQlData = null, folder, alternatePages, seoIndex = true }) => {
  const metaTitle = title && title !== "" ? title : siteGraphQlData.title
  const metaDescription = description && description !== "" ? description : siteGraphQlData.description
  const metaImage = image || siteGraphQlData.image
  const pathname = sanitizeUrl(location.pathname)

  return <>
    <html lang={extractLangAndCountry(folder).lang} />
    <title>{metaTitle}</title>
    <meta name="description" content={metaDescription} />

    {alternatePages && <>
      <link rel="alternate" hrefLang={folder} href={siteGraphQlData.siteUrl + pathname} />
      {Object.keys(alternatePages).map(folder => {
        let href = siteGraphQlData ? (siteGraphQlData.siteUrl + alternatePages[folder]) : ''
        href += href.endsWith("/") ? "" : "/"

        return <link
          rel="alternate"
          hrefLang={folder}
          href={href}
          key={folder}
        />
      })}
    </>}

    {seoIndex === false && <meta name="robots" content="noindex" />}

    <meta property="og:title" content={metaTitle} />
    <meta property="og:type" content="website" />
    <meta property="og:description" content={metaDescription} />
    <meta property="og:image" content={metaImage} />
    <meta property="og:url" content={pathname} />

    <meta name="twitter:card" content="summary" />
    <meta name="twitter:creator" content={siteGraphQlData.author} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={metaDescription} />
  </>
}
HelmetSeo.propTypes = {
  location: PropTypes.any,
  title: PropTypes.any,
  description: PropTypes.any,
  image: PropTypes.any,
  siteGraphQlData: PropTypes.any,
  folder: PropTypes.any,
  alternatePages: PropTypes.any,
  seoIndex: PropTypes.any
}

export default HelmetSeo
